import { z } from "zod";

export const zonalGrossMarginFilterSchema = z.object({
  GranoProductivo: z.array(z.coerce.number()).optional(),
  ZonaProductiva: z.array(z.coerce.number()).optional(),
  CampanaProductiva: z.array(z.coerce.number()).optional(),
  Equilibrio: z.string().optional(),
  RindeEstimado: z.string().optional(),
});

export type ZonalGrossMarginFilterForm = z.infer<typeof zonalGrossMarginFilterSchema>;
